import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    currentList: []
  },
  getters: {},
  mutations: {
    setCurrentList (state, list) {
      state.currentList = list
    }
  },
  actions: {
    async get ({state, commit, dispatch, rootState}, id) {
      return api.getSubscription(id)
    },
    async getList ({state, commit, dispatch, rootState}, newUser) {
      const result = await api.getSubscribers()
      commit('setCurrentList', result)
    },
    async add ({state, commit, dispatch, rootState}, newUser) {
      await api.addSubscription(newUser)
      await dispatch('getList')
    },
    async delete ({state, dispatch}, id) {
      await api.deleteSubscription(id)
      await dispatch('getList')
    },
    async update ({state, dispatch}, subscription) {
      await api.updateSubscription(subscription)
      await dispatch('getList')
    },
    async getMember ({state, dispatch, rootState}) {
      if (!rootState.user.current.isSubscriber) return new Error("401, you should't call this methods")
      const result = await api.getSubscriberMember()
      return result
    },
    async deleteMember ({dispatch}, memberId) {
      await api.deleteSubscriberMember([memberId])
    },
    async getInvitationMemberLink ({rootState}) {
      const invitationId = await api.getInvitationMemberLink(rootState.user.current.subscription)
      return invitationId
    },
    async getInvitationSubscriberLink ({rootState}, subscriptionId) {
      const invitationId = await api.getInvitationSubscriberLink(subscriptionId)
      return invitationId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriber.js